import {Component, Inject} from '@angular/core';
import {environment} from "projects/store/src/environments/environment";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-app.layout-sales',
  templateUrl: './app.layout-sales.component.html'
})
export class AppLayoutSalesComponent {
  srcLogo = `assets/images/${environment.global.country.code}/krediya-logo.svg`;

  constructor(@Inject(DOCUMENT) private document: Document) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if(themeLink) {
      themeLink.href = 'krediya.v2-theme.css';
    }
  }
}
